













































import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { Meta } from '@/helpers/decorators'
import Box from '@/components/common/Box.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

@Component({
  components: {
    Box,
    InputPassword
  }
})
export default class Login extends Mixins(Form, Errors) {
  email: string = null
  password: string = null
  loading: boolean = false
  $api: any

  @Action('createRegistration', { namespace: 'user' }) createRegistration

  @Meta
  metas() {
    return {
      title: this.$t('login.button.submit'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  async login() {
    if (this.formCanBeSubmitted()) {
      try {
        this.loading = true
        await this.createRegistration({ identifier: this.email, password: this.password })
        this.$router.push({ name: 'home' })
      } catch (error) {
        this.displayErrors(error)
      } finally {
        this.loading = false
      }
    }
  }
}
